'use client';
import React from 'react';
import Link from 'next/link';
import { trackBookingCTAClick } from '@/lib/analytics';

interface BookingCTALinkProps {
  href: string;
  trackLabel: string;
  backgroundColor: string;
  children: React.ReactNode;
}

export default function BookingCTALink({ href, trackLabel, backgroundColor, children }: BookingCTALinkProps) {
  return (
    <Link
      href={href}
      onClick={() => trackBookingCTAClick(trackLabel, '/book')}
      className="flex items-center justify-center w-full py-4 rounded-2xl font-bold text-white text-lg transition-all hover:opacity-90"
      style={{ backgroundColor }}>
      {children}
    </Link>
  );
}
